
<q-drawer
  ref="wsDrawerEl"
  v-ws-autofocus="'.q-drawer'"
  class="ws-drawer ws-typography"
  :value="value"
  v-bind="$attrs"
  side="right"
  overlay
  elevated
  :no-swipe-open="$q.platform.is.desktop"
  :no-swipe-close="$q.platform.is.desktop"
  no-swipe-backdrop
  behavior="mobile"
  :width="560"
  @input="handleDrawerVisibility"
>
  <div
    class="ws-drawer-inner fit column no-wrap"
    :class="{ 'full-height-content': fullHeightContent }"
  >
    <div
      v-if="$slots.header"
      class="header"
    >
      <slot name="header"></slot>
    </div>
    <div
      v-else-if="title"
      class="header"
    >
      <div>
        <h5
          v-if="title"
          class="q-mb-xs"
        >
          {{ $t(title) }}
        </h5>
        <slot name="subtitle"></slot>
      </div>

      <div
        v-if="value"
        class="close-wrap"
      >
        <ws-button
          :type="WsButtonEnum.Type.GHOST"
          icon="close"
          @click="handleDrawerVisibility(false)"
        />
      </div>
    </div>
    <div class="content ws-invisible-scrollbar">
      <slot name="content"></slot>
      <slot></slot><!-- default -->
    </div>
    <div
      v-if="$slots.footer"
      class="footer full-width"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</q-drawer>
